import { H2, P1 } from "components/Typography"
import * as css from "./CommitmentsSection.module.css"
import Section from "components/Layout/Section"

function CommitmentsSection() {
  return (
    <Section className={css.section}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
        <div>
          <H2>Open Source FTW</H2>
          <P1>
            We believe that open source is a fundamentally superior approach to
            developing software and we want to contribute to its propagation
            throughout the technology stack. We believe in it from both a
            technical and philosophical standpoint. But at a certain point in
            their evolution, most open-source projects need a commercial push —
            and funding — to take them to the next level. We created Preset
            because we want Superset to be the best open-source analytics
            offering in the world.
          </P1>
        </div>
        <div>
          <H2>Our Commitment</H2>
          <P1>
            Through Preset, we’re committed to doing the hard work needed to
            help Superset reach its full potential. That means investing in
            education, training, and documentation. It also means actively
            supporting the community by hosting meetups and conferences,
            answering questions, and managing releases. We’ll take these steps
            and more in service of the big picture: making sophisticated data
            analysis and insights available to all by providing the right tool
            for the right person.
          </P1>
        </div>
      </div>
    </Section>
  )
}

export default CommitmentsSection
